import React from 'react';
import { IconMessage, IconMoreVert, IconPerson, IconSynchronized } from '../icons/svg';
import { Tinode } from '../tinode/tinode';
import { GROUP_MEMBER_VIEW_TYPE } from '../tinode/constants'
import { FormattedMessage, injectIntl } from 'react-intl';

class MenuContacts extends React.PureComponent {
  constructor(props) {
    super(props)

    this.handleShowCreateGroupPopup = this.handleShowCreateGroupPopup.bind(this)
  }

  handleShowCreateGroupPopup() {
    this.props.handleShowGroupMembers({
      groupView: GROUP_MEMBER_VIEW_TYPE.CREATE_GROUP,
    })
  }

  render() {
    return (
      <div className="menu-contact">
        <div className="options" onClick={this.handleShowCreateGroupPopup}>
          <div className="tooltip-container">
            <IconPerson />
            <div className="tooltip tooltip-left">
              <FormattedMessage
                id="dialog_title_create_group"
                defaultMessage="Create group"
              />
            </div>
          </div>
        </div>
        <div className="options" onClick={this.props.onMarkReadAllMessage}>
          <div className="tooltip-container">
            <IconSynchronized />
            <div className="tooltip tooltip-left">
              <FormattedMessage
                id="sidepanel_title_read_all"
                defaultMessage="Read all"
              />
            </div>
          </div>
        </div>
        {/* <div className="options" onClick={this.props.onNewTopic}>
          <IconMessage />
        </div> */}
        <div className="options" onClick={() => this.props.onShowDialog(Tinode.DIALOG_TYPE.SETTING)}>
          <div className="tooltip-container">
            <IconMoreVert />
            <div className="tooltip tooltip-left">
              <FormattedMessage
                id="sidepanel_title_settings"
                defaultMessage="Settings"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default injectIntl(MenuContacts)